var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("system-settings-payment"),
        _vm._v(" "),
        _c("system-settings-notifications"),
        _vm._v(" "),
        _vm.settings && _vm.settings.booking_custom_fields !== undefined
          ? _c("system-settings-custom-fields", {
              attrs: {
                endpoint: "settings/booking_custom_field",
                attribute: "booking_custom_fields",
                title: "Booking Custom Fields",
                customFieldValues: this.settings.booking_custom_fields,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.settings && _vm.settings.user_custom_fields !== undefined
          ? _c("system-settings-custom-fields", {
              attrs: {
                endpoint: "settings/user_custom_field",
                attribute: "user_custom_fields",
                title: "User Custom Fields",
                customFieldValues: this.settings.user_custom_fields,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("system-settings-terms-and-condition"),
        _vm._v(" "),
        _c("system-settings-social-media"),
        _vm._v(" "),
        _c("system-settings-app-version"),
        _vm._v(" "),
        _c("system-settings-others"),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Settings")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }